import { joinParts } from '../utils'

export const guest = {
  getCards: () => joinParts('guests', 'cards'),
  saveCard: (paymentMethodId: string) => joinParts('guests', 'cards', paymentMethodId),
  deleteCard: (paymentMethodId: string) => joinParts('guests', 'cards', paymentMethodId),
}
